<template>
  <v-form v-model="valid" style="height: inherit">
    <v-container fluid style="height: inherit">
      <v-row align="stretch" style="height: inherit;">
        <v-col :cols="isPhoneBool ? 12 : 6">
          <h3 v-text="$t('servicesystem.common_objects.commonterms.details')" class="mx-3" />
          <PartnerCompanyEditContent :editItem="editItem" :editMode="true">
          </PartnerCompanyEditContent>
        </v-col>

        <v-col :cols="isPhoneBool ? 12 : 6" style="background-color: rgb(248, 248, 248) !important;">
          <v-row no-gutters>
            <v-col cols="12">
              <h3 v-text="$t('servicesystem.common_objects.commonterms.address')" class="mx-3" />
              <PartnerCompanyAddressEditContent :editItem="editItem" :editMode="true">
              </PartnerCompanyAddressEditContent>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <v-row no-gutters>
            <v-col cols="12">
              <h3 v-text="$t('servicesystem.common_objects.partner_company.manager')" class="mx-3" />
              <PartnerCompanyContactEditContent :editItem="editItem" :editMode="true">
              </PartnerCompanyContactEditContent>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-btn :color="valid ? 'quaternary' : 'disabled'" :disabled="!valid"
        style="position: fixed; bottom: 50px; right: 16px; color: white;" @click="create()">
        <v-icon size="16" class="mr-1">mdi-content-save</v-icon>
        {{ $t("servicesystem.common_objects.commonterms.create") }}
      </v-btn>
    </v-container>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import PartnerCompanyEditContent from "@/views/admin/partnercompany/PartnerCompanyEditContent.vue";
import PartnerCompanyAddressEditContent from "@/views/admin/partnercompany/PartnerCompanyAddressEditContent.vue";
import PartnerCompanyContactEditContent from "@/views/admin/partnercompany/PartnerCompanyContactEditContent.vue";

export default {
  name: "NewPartnerCompany",
  props: {},
  components: {
    PartnerCompanyEditContent,
    PartnerCompanyAddressEditContent,
    PartnerCompanyContactEditContent,
  },
  mixins: [clientAPI],

  data() {
    return {
      valid: false,
      editItem: {},
    };
  },

  mounted() { },

  methods: {
    async create() {
      const dto = Object.assign({}, this.editItem);
      await this.createPartnerCompany(dto)
        .then((response) => {
          response.new = true;
          this.$emit("Added", response);
        })
        .catch((exception) => {
          console.error(exception);
        });
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>